module.exports = __webpack_public_path__ + "static/media/sesame.11e2a0be.png";